module.exports = __webpack_public_path__ + "assets/542552762e97e40af59d390abfcf94d2.png";